import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { NivalizOutboundTransactionVolumeByStateListChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { TransactionStateName } from '@frontend/transaction/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getLast30DaysChartRange } from '../last-30-days-chart-range';
import { Last30DaysNivalizOutboundTransactionVolumeByStateListChartProps } from './last-30-days-nivaliz-outbound-transaction-volume-by-state-list-chart.component';

export const useLast30DaysNivalizOutboundTransactionVolumeByStateListChart = (props: Last30DaysNivalizOutboundTransactionVolumeByStateListChartProps) => {
    const navigate = useNavigate();
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);
        const { after, before } = getLast30DaysChartRange();

        ChartClient.fetchChartData(props.accountId, NivalizOutboundTransactionVolumeByStateListChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    const getNavigateTarget = (key: TransactionStateName) => {
        switch (key) {
            case TransactionStateName.TRANSACTION_DROP_OFF_PENDING:
                return '../urns?tab=awaiting_drop_off';
            case TransactionStateName.TRANSACTION_PICK_UP_PENDING:
                return '../urns?tab=awaiting_pick_up';
            case TransactionStateName.TRANSACTION_FAILED:
                return '../urns?tab=failed';
            case TransactionStateName.TRANSACTION_COMPLETED:
                return '../urns?tab=completed';
            default:
                return '../urns';
        }
    };

    return { data, isLoading, getNavigateTarget, navigate };
};
